export const isArrayOfLength = (item, length) => Array.isArray(item) && item.length === length

export const isArrayOfPairs = value => {
  return (
    Array.isArray(value) &&
    value.reduce((acc, item) => {
      return acc && isArrayOfLength(item, 2)
    }, true)
  )
}

// Returns a boolean if all props in Array "props" are defined on Object "obj"
export const checkAllPropsPresent = (obj, props) =>
  props.reduce((acc, prop) => {
    return acc && Object.prototype.hasOwnProperty.call(obj, prop)
  }, true)

// Check if passed in object is a function
export const isFunction = obj => {
  return !!(obj && obj.constructor && obj.call && obj.apply)
}
